export interface IShape {
  borderRadiusDefault: string;
  borderRadiusXSmall: string;
  borderRadiusSmall: string;
  borderRadiusMedium: string;
  borderRadiusLarge: string;
}

export const Shape = {
  borderRadiusDefault: "8px",
  borderRadiusXSmall: "16px",
  borderRadiusSmall: "20px",
  borderRadiusMedium: "24px",
  borderRadiusLarge: "28px",
};
